<template>

  <div class="product-add pb50">
   <!--添加信息-->
    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加信息</div>

      <el-form-item label="信息分类">
        <el-select v-model="form.category_id" placeholder="请选择">
          <el-option v-for="(item, index) in catgory" :key="index" :label="item.name" :value="item.category_id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="信息标题" prop="material_title">
        <el-input type="text" v-model="form.material_title" autocomplete="off" placeholder="请输入信息标题" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="排序">
        <el-input type="number" v-model="form.material_sort" placeholder="请输入数字" class="max-w460"></el-input>
        <div class="gray">数字越小越靠前</div>
      </el-form-item>

      <el-form-item label="状态">
        <el-radio-group v-model="form.material_status">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="信息详情" prop="form.dec">
        <el-input type="textarea" rows="5" v-model="form.dec" autocomplete="off" placeholder="信息详情" class="max-w460"></el-input>
      </el-form-item>

      <!--内容-->
     <!-- <el-form-item label="信息详情">
        <div class="d-s-c">
          <div class="edit_container">
            <Uediter :text="form.dec" :config="ueditor.config" ref="ue"></Uediter>
          </div>

        </div>
      </el-form-item> -->

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="{ total: 1 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>

  </div>
</template>

<script>
import MaterialApi from '@/api/material5.js';
import Upload from '@/components/file/Upload';
import Video from '@/components/file/Video';
import draggable from 'vuedraggable';
import Uediter from '@/components/UE.vue';
export default {
  components: {
    Video: Video,
    /*图片上传*/
    Upload: Upload,
    draggable,
    Uediter
  },
  data() {
    return {
      /*是否打开产品弹出层*/
      isproduct: false,
      /*是否上传图片*/
      isupload: false,
      isvideoupload:false,
      isImg: false,
      isVideo: false,

      isProductUpload: false,

      path: '',
      videopath: '',
      /*form表单数据*/
      form: {
        mtype:5,
        product_id:0,
        nickName:'',
        material_title: '',
        material_p: '',
        labels:'',
        category_id: '',
        product_id: '',
        image_id: '',
        video_id:'',
        avatar:"",
        material_sort: 1,
        material_status: 1,
        virtual_views: 1,
        image: [],
        dec: '',
        material_type:10,
      },
      product:{},
      /*信息类别*/
      catgory: [],
      loading: false,
      /*验证规则*/
      rules: {
        material_title: [{ required: true, message: '请输入信息标题', trigger: 'blur' }]
      },

      /*富文本框配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },

    };
  },

  created() {
    /*获取列表*/
    this.getCategoryList();
  },
  methods: {
    /*打开上传图片*/
    openProductUpload: function() {
      this.isProductUpload = true;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        let imgs = this.form.image.concat(e);
        this.$set(this.form, 'image', imgs);
      }
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(e) {
      for (var i = 0; i < this.form.image.length; i++) {
        if (e.file_id == this.form.image[i].file_id) {
          this.form.image.splice(i, 1);
        }
      }
    },
    /*上传*/
    openUpload() {
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.avatar = e[0].file_id;
        this.path = e[0].file_path;
        this.isImg = true;
      }
      this.isupload = false;
    },
    /*上传视频*/
    openVideoUpload() {
      this.isvideoupload = true;
    },

    /*获取视频*/
    returnVideoFunc(e) {
      let self = this;
      if (e != null) {
        this.form.video_id = e[0].file_id;
        this.videopath = e[0].file_path;
        this.isVideo = true;
      }
      this.isvideoupload = false;
    },
    /*获取信息类别*/
    getCategoryList() {
      let self = this;
      let Params = {};

      MaterialApi.toAddMaterial(Params, true)
        .then(res => {
          self.catgory = res.data.catgory;
          if(self.catgory.length > 0){
            self.form.category_id = self.catgory[0].category_id;
          }
        })
        .catch(error => {

        });
    },

    /*添加信息*/
    onSubmit() {
      let self = this;
      let form = self.form;
      // form.dec = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          MaterialApi.materialAdd(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.$router.push('/plus/material5/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回信息列表*/
    cancelFunc() {
      this.$router.push({
        path: '/plus/material5/index'
      });
    },
    /*删除商品*/
    deleteFunc() {
      this.form.product_id = 0;
      this.product = {};
    },

    /*产品列表弹出层*/
    openProduct() {
      this.isproduct = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e) {
      this.isproduct = e.openDialog;
      console.log(e)
      if (e.type == 'success') {
        this.form.product_id = e.params.product_id;
        this.product = e.params;
      }
    },


  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/material5/material/add.vue